import { updateConversationApiConversationsSessionIdPut } from "@noa/api-core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reportError } from "../../typed-client";
import { ApiError } from "../../errors";
import { ConversationQueryKey } from "../../query-keys";

interface RenameConversationParams {
  sessionId: string;
  name: string;
}

const renameConversationRequest = async ({ sessionId, name }: RenameConversationParams) => {
  await updateConversationApiConversationsSessionIdPut({
    path: { session_id: sessionId },
    body: { name },
    throwOnError: true,
  });
};

export const useRenameConversation = () => {
  const queryClient = useQueryClient();
  return useMutation<void, ApiError, RenameConversationParams>({
    mutationFn: renameConversationRequest,
    onError: reportError,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ConversationQueryKey.all });
    },
  });
};
